import 'css-chunksrc/feature/payment/PartialPaymentModal.module.scss';export default {
  "form": "PartialPaymentModal_form"
};